import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Event extends BaseApi{
  static getClassName(){ return 'Event' }

  static getEvent(input){
    return app.make("axios").get(`v1/event/${input["event_id"]}`,{
      params: {
        with_photos:input["with_photos"] || 0,
        with_categories:input["with_categories"] || 0,
        by_catalog_page:input["by_catalog_page"] || 0,
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  /**
   */
  static getViewingEvents(input){
    return app.make("axios").get(`v1/viewing-event`,{
        params: {
        }
      })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static isEventActivated(input){
    return app.make("axios").get(`v1/event/${input["event_id"]}/check-event-activated`,{
      params: {
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static eventKeyActivation(input){
    return app.make("axios").post(`v1/event/${input["event_id"]}/event-key-activation`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

}
export default Event



// WEBPACK FOOTER //
// ./src/api/Event.js